export const config = {
  url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS3GK8lbCHlqz3MA7CSftWo35ulGmq2AO5UuBty-lAemvCyOi7XSTPp8364pEeNSq9F8qK08Uii20Lf/pub?gid=0&single=true&output=csv",
  // title: "Virginia Tech Authors 2019-2022",
  // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
  searchFields: ["Description", "Workshop", "Time Range", "Max Group Size", "Grade range", "Studio(s)"],
  headers: [
    {
      key: "Workshop",
      value: "Workshop",
      minWidth: "200px",
    },
    {
        key: "Description",
        value: "Description",
        minWidth: "350px",
    },
    {
        key: "Time Range",
        value: "Time Range",
        width: "120px",
    },
    {
        key: "Max Group Size",
        value: "Max Group Size",
        width: "120px",
    },
    {
        key: "Grade range",
        value: "Grade range",
        minWidth: "150px",
    },
    {
        key: "Studio(s)",
        value: "Studio(s)",
        minWidth: "200px",
    },
  ],
  link: false,
};
